import { styled, StyleProps } from "../styles"

interface Props extends StyleProps {
  ref?: React.ForwardedRef<HTMLInputElement>
  disabled?: boolean
}

export const StyledInput = styled.input<Props>((props: Props) => ({
  background: `unset`,
  border: `none`,
  outline: `none`,
  width: `100%`,
  height: `100%`,
  color: props.theme.palette.coal.dark,
  cursor: props.disabled ? `not-allowed` : `text`,
  fontWeight: props.theme.fonts.body.fontWeight,
}))
